import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { PublicRoute } from "routers/PublicRoute";
import { NoSearchEngineTemplate } from "templates/NoSearchEngineTemplate";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { changeUserEmail } from "services/fetch-change-user-email";

export const PageEditEmailConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [time, setTime] = useState(10);
/*   const email = new URLSearchParams(location.search).get("code"); */
  const rest = new URLSearchParams(location.search).get("id")
  const token = new URLSearchParams(location.search).get("token")
  const [isValid, setIsValid] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime((prev) => Math.max(prev - 1, 0));
    }, 1000);
    if (time === 0) {
      clearInterval(interval);
      navigate("/login");
    }
    return () => clearInterval(interval);
  }, [time]);

  useEffect(() => {
    const execute = async (token: string) => {
      try {
        if (!rest) {
           throw new Error("Id inválido")
        }

        const response = await changeUserEmail(rest, token);

        if (response === 200) {
          setIsValid(true);
        }
      } catch (error) {
        toast.error(
          "Token inválido"
        )
      } finally {
        setIsLoaded(true);
      }
    };

    if (!token) {
      toast.error(
        "Token não encontrado"
      )
      return;
    }
    execute(token);
  }, [token]);

  if (!isLoaded) {
    return null;
  }

  if (!isValid && isLoaded) {
    return (
      <PublicRoute>
        <NoSearchEngineTemplate>
          <div className="h-[calc(100vh-233px)] flex items-center justify-center">
            <div>
              <div className="flex flex-col items-center space-y-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="text-red-600 w-28 h-28"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="1"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
                <h1 className="text-4xl font-bold">
                  Sinto muito! Ocorreu um erro na confirmação do seu e-mail.
                </h1>
                <a
                  href="/login"
                  className="inline-flex items-center px-4 py-2 text-white bg-indigo-600 border border-indigo-600 rounded-full hover:bg-indigo-700 focus:outline-none focus:ring"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3 h-3 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M7 16l-4-4m0 0l4-4m-4 4h18"
                    />
                  </svg>
                  <span className="text-sm font-medium">
                    Ir para a página de login
                  </span>
                </a>
                <p className="text-gray-500 text-xs">
                  Você será redirecionado em {time} segundos
                </p>
              </div>
            </div>
          </div>
        </NoSearchEngineTemplate>
      </PublicRoute>
    );
  }

  return (
    <PublicRoute>
      <NoSearchEngineTemplate>
        {token ? (
          <div className="h-[calc(100vh-233px)] flex items-center justify-center">
            <div>
              <div className="flex flex-col items-center space-y-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="text-green-600 w-28 h-28"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="1"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <h1 className="text-4xl font-bold">
                  Email confirmado com sucesso
                </h1>
                <p>
                  Agora você pode fazer login e começar a usar a plataforma.
                </p>
                <a
                  href="/login"
                  className="inline-flex items-center px-4 py-2 text-white bg-indigo-600 border border-indigo-600 rounded-full hover:bg-indigo-700 focus:outline-none focus:ring"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3 h-3 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M7 16l-4-4m0 0l4-4m-4 4h18"
                    />
                  </svg>
                  <span className="text-sm font-medium">
                    Ir para a página de login
                  </span>
                </a>

                <p className="text-gray-500 text-xs">
                  Você será redirecionado em {time} segundos
                </p>
              </div>
            </div>
          </div>
        ) : (
          <PublicRoute>
            <div className="flex flex-col items-center justify-center h-screen text-2xl">
              <span className="text-gray-700 font-semibold">
                Redirecionando para o login...
              </span>
              <p className="text-gray-500 text-xs mt-1">
                Você será redirecionado em {time} segundos
              </p>
            </div>
            <Toaster
              position="top-center"
              toastOptions={{
                duration: 5000,
              }}
            />
          </PublicRoute>
        )}
      </NoSearchEngineTemplate>
    </PublicRoute>
  );
};
